var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 40,
  width: 40
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.25 33.958q-.708.25-1.312-.208-.605-.458-.605-1.25 0-.375.209-.667.208-.291.583-.416 3.625-1.334 5.854-4.438 2.229-3.104 2.229-7.021 0-3.916-2.229-7.041Q27.75 9.792 24.125 8.5q-.375-.125-.583-.438-.209-.312-.209-.687 0-.792.605-1.229.604-.438 1.312-.188 4.375 1.625 7.062 5.438Q35 15.208 35 19.958t-2.688 8.563q-2.687 3.812-7.062 5.437ZM6.375 25q-.583 0-.979-.396T5 23.625v-7.25q0-.583.396-.979T6.375 15h5.292l5.958-5.958q.667-.667 1.521-.313Q20 9.083 20 10v20q0 .917-.854 1.271-.854.354-1.521-.313L11.667 25Zm16.417 1.875V13.042q2.125.791 3.416 2.708Q27.5 17.667 27.5 20q0 2.375-1.292 4.25-1.291 1.875-3.416 2.625Z"
})));

export default SvgAudio;